// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8d041134","732":"40734dd5","977":"7b6cd64d"}[chunkId] + ".chunk.js";
};